import { render, staticRenderFns } from "./rebate_ratio.vue?vue&type=template&id=1d2ccbd6&scoped=true&"
import script from "./rebate_ratio.vue?vue&type=script&lang=js&"
export * from "./rebate_ratio.vue?vue&type=script&lang=js&"
import style0 from "./rebate_ratio.vue?vue&type=style&index=0&id=1d2ccbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ccbd6",
  null
  
)

export default component.exports